import Vue from 'vue';

Vue.prototype.$bus = new Vue();


// WEBPACK FOOTER //
// ./src/bus.js